export const storageUtil = {
  set(key: string, value: any) {
    localStorage.setItem(key, JSON.stringify(value));
  },

  get(key: string) {
    const item = localStorage.getItem(key);
    try {
      return JSON.parse(item!);
    } catch {
      return item; // 如果不是 JSON 格式，直接返回字符串
    }
  },

  remove(key: string) {
    localStorage.removeItem(key);
  },

  clear() {
    localStorage.clear();
  },
};
